import request from "@/utils/request";
import {
  createStaticResult,
  getNewsDetail,
  getNewsList,
  getNewsRecommendList,
  getNewsTypeList,
  mapVoteActivity,
} from "@/data/siteContent";

export function artNewsList(params) {
  return createStaticResult(getNewsList(params.classify));
}

export function artActivityList(params) {
  return request.get("/vote/activity/list", params, { login: false }).then((res) => ({
    ...res,
    data: {
      content: (res.data || []).map((item) => mapVoteActivity(item)),
    },
  }));
}

export function artNewsDetail(id) {
  return createStaticResult(getNewsDetail(id));
}

export function artNewsRecommendList(params) {
  return createStaticResult(getNewsRecommendList(params.classify, params.id));
}

export function artNewsTypeList(params) {
  return createStaticResult(getNewsTypeList(params.classify, params.id));
}

export function artActivityDetail(id) {
  return request
    .get(`/vote/activity/detail/${id}`, { isShow: 0, uid: 0 }, { login: false })
    .then((res) => ({
      ...res,
      data: mapVoteActivity(res.data),
    }));
}

export function artActivityRecommendList(params) {
  const query = {
    page: 1,
    limit: params.limit || 6,
  };

  return request.get("/vote/activity/list", query, { login: false }).then((res) => ({
    ...res,
    data: (res.data || []).map((item) => mapVoteActivity(item)).slice(0, params.limit || 6),
  }));
}

export function artActivityTypeList() {
  return request.get("/vote/activity/list", { page: 1, limit: 3 }, { login: false }).then((res) => {
    const list = (res.data || []).map((item) => mapVoteActivity(item));
    return {
      ...res,
      data: {
        hot: list[0] || null,
        news: list[1] || null,
        related: list[2] || null,
      },
    };
  });
}

export function registerActivity(params) {
  return createStaticResult(
    {
      redirectPath: `/ContestApply/${params.activityId || ""}`,
    },
    {
      msg: "请从当前活动的报名入口继续提交",
    }
  );
}
